module.exports = __webpack_public_path__ + "img/foto11.b239191d.jpg";